import React from "react";
import { produce } from "immer";
import { MultistepFilter } from "@sscs/ui";
import { AuditFilters } from "../../types";
import { useFilterOptions } from "./useFilterOptions";

type FilterProps = {
  filters: AuditFilters;
  onFilterChange: (filters: AuditFilters) => void;
};

const Filter = ({
  filters,
  onFilterChange,
}: FilterProps): React.JSX.Element | null => {
  const filterOptions = useFilterOptions({ filters });

  if (!filterOptions) return null;

  return (
    <MultistepFilter
      activeFilters={filters}
      filterOptions={filterOptions}
      onFilterSave={(filterName, filter) => {
        onFilterChange(
          produce(filters, (draft) => {
            draft[filterName] = filter;
          }),
        );
      }}
      onFilterDelete={(filterName) =>
        onFilterChange(
          produce(filters, (draft) => {
            delete draft[filterName];

            if (filterName === "resource_type") {
              delete draft["resource_name"];
            }
          }),
        )
      }
    />
  );
};

export default Filter;
